// Legacy colors - now using White Label system from public/whiteLabel/default.json
// Keep only utility colors that are not theme-dependent
export const COLORS = {
  background: {
    light: '#ffffff',
    dark: '#0f172a',
  },
  text: {
    light: '#1F2937',
    dark: '#ffffff',
  },
  gray: {
    100: '#f3f4f6',
    800: '#1f2937',
  },
  progressBg: {
    light: '#e5e7eb',
    dark: '#374151',
  },
  card: {
    light: '#F5F7F9',
    dark: '#191C1E',
  },
};
